export default "__VITE_ASSET__CkLnrT5L__"